module.exports = __webpack_public_path__ + "static/assets/3ec293692bbf3e8eb82f1e191c782ca4.png";